import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollRestoration = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if this is a browser back/forward navigation
    const isBackForwardNavigation = window.performance && 
      window.performance.navigation.type === 2;

    if (isBackForwardNavigation) {
      // Let browser handle scroll restoration for back/forward
      return;
    }

    // For regular navigation (clicking links)
    if (location.hash) {
      // If there's a hash, scroll to that element after a delay
      setTimeout(() => {
        const element = document.getElementById(location.hash.substring(1));
        if (element) {
          const yOffset = -100;
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 100);
    } else {
      // No hash, scroll to top for new page navigation
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);

  return null;
};

export default ScrollRestoration;
